import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function LjudskaPravaISlobode() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Ljudska prava i slobode" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Ljudska prava i slobode</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Ljudska prava i slobode
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet Ljudska prava i slobode ima za cilj da se izučavanjem
                ovog predmeta steknu znanja o ljudskim pravima kako bi studenti
                stekli vještine prepoznavanja situacija u kojima su ljudska
                prava ugrožena kao i sredstva zaštite u slučaju nepoštovanja i
                kršenja ljudskih prava. Naročito se naglašava zaštita ljudskih
                prava pred međunarodnim organizacijama kao što je Evropski sud
                za ljudska prava kao i nacionalni i regionalni mehanizmi
                zaštite.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon što student položi ovaj ispit moći će da poveže i zaokruži
                znanja iz oblasti ljudskih prava imajući u vidu činjenicu da se
                oblast ljudskih prava u mnogim aspektima već proučava kroz druge
                predmete na pravnom fakultetu. Takođe studenti će u potpunosti
                ovladati Evropskom konvencijom za zaštitu ljudskih prava i
                temeljnih sloboda, njenu strukturu, značaj, koncept negativnih i
                pozitivnih obveza države prema Konvenciji, odnos domaćeg
                pravosuđa, pozivanje na Konvenciju kao i kritički osmatrati
                stanje ljudskih prava i sloboda u Crnoj Gori kao i načine za
                unaprijeđivanje istih.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong> Nastanak i razvoj ideje
                ljudskih prava, Definicija ljudskih prava (pojam i predmet),
                Izvori, klasifikacija izvora. Vrste ljudskih prava. Politički
                integritet ličnosti; sloboda izražavanja mišljenja –
                informisanja; prava na okupljanje, udruživanje, učešće u vlasti,
                aktivno i pasivno biračko pravo. Građanska i politička prava;
                opšti pojam i pravna priroda; životni i fizički integritet
                ličnosti; pravo na život; zabrana mučenja i sličnih postupka;
                zabrana ropstva i sličnih ustanova, sloboda kretanja. Pravni
                integritet ličnosti; pravo na pravni subjektivitet; pravo na
                državljanstvo; pravo na zakonit i pravičan sudski postupak;
                zabrana nezakonitog i samovoljnog lišavanja slobode; pravo na
                slobodu kretanja, azil; zabrana diskriminacije. Lični moralni i
                duhovni integritet pojedinca; pravo na privatnost; pravo na
                poštovanje imovine; slobode mišljenja, savjesti i
                vjeroispovjesti. Internacionalizacija zaštite ljudskih prava.
                Univerzalna deklaracija o ljudskim pravima, pojam i pravna
                priroda; međunarodni ugovori-paktovi o ljudskim pravima; Pakt o
                građanskim i političkim pravima; Pakt o ekonomskim, socijalnim i
                kulturnim pravima. Regionalni sistemi za zaštitu ljudskih prava.
                Sistem kontrole i implementacije. Ekonomski i socijalni
                integritet ličnosti; prava društvenog blagostanja; pojam, pravna
                priroda i mehanizmi implementacije. Ljudska prava treće
                generacije; pojam, pravna priroda i mehanizmi zaštite. Rodna
                ravnopravnost, prava djeteta i prava osoba s invaliditetom.
                Tranziciona pravda, međunarodni krivični sudovi, međunarodna
                krivična djela, individualna krivična odgovornost. Ograničenja i
                restrikcije u uživanju ljudskih prava; privremeno stavljanje van
                snage pojedinih prava u vanrednim okolnostima; opšta
                fakultativna ograničenja; inherentna ograničenja stalnog
                karaktera. Osnovni principi zaštite čovjeka u oružanim sukobima;
                osnovna načela humanitarnog prava; izvori međunarodnog ratnog i
                humanitarnog prava; karakter obaveza koje proizilaze iz
                humanitarnog prava; problemi implementacije humanitarnog prava.
                Zaštita izbjeglica, interno raseljenih lica, imigranata,
                azilanata i apatrida. Zaštita ljudskih prava pripadnika
                nacionalnih manjina; položaj domorodačkih (urođeničkih) naroda;
                kolektivna prava; pravo naroda na samoopredeljenje.
              </p>
              <p>
                Mjere implementacije u okviru međunarodnih sudova; Evropski sud
                za ljudska prava u Strazburu; nevladine organizacije i
                implementacija ljudskih prava. Pojam i sadržina masovnih i
                sistematskih kršenja ljudskih prava; osnovne protivrječnosti u
                sistemu ljudskih prava koje ograničavaju njihovu primjenu;
                ljudska prava i ljudske obaveze. Mjere implementacije u okviru
                međunarodnih organizacija; sistem periodičnih izvještaja;
                postupci po žalbama jedne države protiv druge, postupci po
                žalbama pojedinaca i nevladinih organizacija. Primjena i nadzor
                nad primjenom ljudskih prava (implementacija); pojam i vrste
                mjera implementacije; unutrašnje mjere implementacije;
                međunarodne mjere implementacije.
              </p>
              <p>
                <strong>Praktična nastava:</strong> Praktična nastava se izvodi
                u prostorijama fakulteta na predavanjima i vježbama, kao i van
                prostorija u okviru studijskih poslova. Studenti će u okviru
                studijskih posjeta posjetiti relevantne međunarodne
                organizacije, nadležne državne organe kao i NVO sektor. Naravno,
                na časovima i predavanjima studenti će analizirati sudsku praksu
                kako domaćih tako i međunarodnih sudova.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja, vježbe, analiza konkretnih stvarnih i hipotetičkih
                slučajeva, seminarski rad, konsultacije, debate, kolokvijumi,
                završni ispit. Interaktivna nastava koja obuhvata uvodno
                izlaganje od strane predavača i učešće studenata u diskusiji;
                Predavanja i vježbe praćena su odgovarajućim posebno izrađenim
                prezentacijama.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Nastanak i razvoj ideje ljudskih prava Definicija ljudskih
                      prava (pojam i predmet) Izvori klasifikacija izvora. Vrste
                      ljudskih prava.
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Internacionalizacija zaštite ljudskih prava. Univerzalna
                      deklaracija o ljudskim pravima pojam i pravna priroda;
                      međunarodni ugovori-paktovi o ljudskim pravima; Pakt o
                      građanskim i političkim pravima; Pakt o ekonomskim
                      socijalnim i kulturnim pravima. Regionalni sistemi za
                      zaštitu ljudskih prava. Sistem kontrole i implementacije.
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Građanska i politička prava; opšti pojam i pravna priroda;
                      životni i fizički integritet ličnosti; pravo na život;
                      zabrana mučenja i sličnih postupka; zabrana ropstva i
                      sličnih ustanova sloboda kretanja.
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>
                      Pravni integritet ličnosti; pravo na pravni subjektivitet;
                      pravo na državljanstvo; pravo na zakonit i pravičan sudski
                      postupak; zabrana nezakonitog i samovoljnog lišavanja
                      slobode; pravo na slobodu kretanja, azil; zabrana
                      diskriminacije. Lični moralni i duhovni integritet
                      pojedinca; pravo na privatnost; pravo na poštovanje
                      imovine; slobode mišljenja, savjesti i vjeroispovjesti.
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Politički integritet ličnosti; sloboda izražavanja
                      mišljenja – informisanja; prava na okupljanje,
                      udruživanje, učešće u vlasti, aktivno i pasivno biračko
                      pravo.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P + 2V</td>
                    <td>Praktična nastava. Posjeta NVO organizacijama.</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Ekonomski i socijalni integritet ličnosti; prava
                      društvenog blagostanja; pojam pravna priroda i mehanizmi
                      implementacije. Ljudska prava treće generacije; pojam
                      pravna priroda i mehanizmi zaštite. Rodna ravnopravnost,
                      prava djeteta i prava osoba s invaliditetom.
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>Praktična nastava. Posjeta UNICEF-u.</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      Zaštita ljudskih prava pripadnika nacionalnih manjina;
                      položaj domorodačkih (urođeničkih) naroda; kolektivna
                      prava; pravo naroda na samoopredeljenje.
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>
                      Ograničenja i restrikcije u uživanju ljudskih prava;
                      privremeno stavljanje van snage pojedinih prava u
                      vanrednim okolnostima; opšta fakultativna ograničenja;
                      inherentna ograničenja stalnog karaktera.
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>
                      Osnovni principi zaštite čovjeka u oružanim sukobima;
                      osnovna načela humanitarnog prava; izvori međunarodnog
                      ratnog i humanitarnog prava; karakter obaveza koje
                      proizilaze iz humanitarnog prava; problemi implementacije
                      humanitarnog prava. Zaštita izbjeglica, interno raseljenih
                      lica, imigranata, azilanata i apatrida.
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>2P + 2V</td>
                    <td>
                      Praktična nastava. Analiza sudske prakse međunarodnih
                      sudova.
                    </td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Primjena i nadzor nad primjenom ljudskih prava
                      (implementacija); pojam i vrste mjera implementacije;
                      unutrašnje mjere implementacije; međunarodne mjere
                      implementacije;
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>
                      Mjere implementacije u okviru međunarodnih organizacija;
                      sistem periodičnih izvještaja; postupci po žalbama jedne
                      države protiv druge, postupci po žalbama pojedinaca i
                      nevladinih organizacija.
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>
                      Mjere implementacije u okviru međunarodnih sudova;
                      Evropski sud za ljudska prava u Strazburu; nevladine
                      organizacije i implementacija ljudskih prava. Pojam i
                      sadržina masovnih i sistematskih kršenja ljudskih prava;
                      osnovne protivrječnosti u sistemu ljudskih prava koje
                      ograničavaju njihovu primjenu; ljudska prava i ljudske
                      obaveze.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3.00h</td>
                            <td>Ukupno: 80 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 1.3h</td>
                            <td>Nastava + završni ispit: 60 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 6 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default LjudskaPravaISlobode;
